// NOTE:
// for now, contain the firebase data modification over here for easier refactoring
// TODO: separate implementation from the needs

import { db } from '@/firebase'

// const usersRef = db.ref('users')

const streamingRefs = []

function cleanupStreamingRefs() {
  streamingRefs.map((refObj) => {
    refObj.ref.off('value', refObj.listener)
  })
}

async function getUserInfo(user) {
  // input: pass in user/userID
  const data = await db.ref(`users/${user}`).once('value').then(snapshot => snapshot.val())
  // return: get relevant user info
  return data
}

async function streamUserInfo(user, callback) {
  const ref = db.ref(`users/${user}`)
  const onUserInfoUpdate = ref.on('value', function(snapshot) {
    callback(snapshot.val())
  })
  streamingRefs.push({ ref, listener: onUserInfoUpdate })
}

// TODO: implement getUploadedPics
function getUploadedPics(user) {
  return []
}

function AgentNotes(user) {
  const ref = db.ref(`users/${user}/agentNotes`)
  return {
    async get() {
      const data = await ref.once('value').then((snapshot) => {
        const val = snapshot.val()
        if (val) {
          // map key into note's id
          const entries = Object.entries(val)
          const notes = []
          for (let entry of entries) {
            const [key, value] = entry
            const note = Object.assign({ id: key }, value)
            notes.push(note)
          }
          return notes
        } else {
          return []
        }
      })
      return data
    },
    async push(note) {
      const noteRef = ref.push()
      await noteRef.set(note)
      return noteRef.key // noteID *
    },
    async delete(noteID) {
      const noteRef = ref.child(noteID)
      await noteRef.set(null)
    },
  }
}

function UploadComplain(timestamp) {
  const ref = db.ref(`custom/CRM/${timestamp}`)
  return {
    async update(complain) {
      await ref.update(complain)
      return ref.key // noteID *
    },
  }
}

export {
  getUserInfo,
  streamUserInfo,
  getUploadedPics,
  AgentNotes,
  UploadComplain,
  cleanupStreamingRefs,
}



// WEBPACK FOOTER //
// ./src/dbApi.js